import React from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'

import Skills from './Skills';

export default function TabListDesktop(){
   return (
     <Tabs>
      <TabList className="react-tabs__tab-list collapse" id="experienceMenu">
         <Tab>Freelance</Tab>
         <Tab>Southland Supply Group</Tab>
         <Tab>More2Make / Wolplein</Tab>
         <Tab>Aemotion</Tab>
         <Tab className="skills-tab react-tabs__tab">Skills</Tab>
      </TabList>
      <TabPanel>
      <h3 className="work-description">Web Developer - Freelance (i.a. Southland Supply Group, Dezign, Hammond & Grange, Grange & Baker)</h3>
      <p className="work-duration">Okt 2020 - Present</p>
      <ul className="work-description">
       <li>Designing, developing and maintaining various web applications by using for example Magento 1 & 2, Wordpress.</li>
       <li>Development of tailor-made modules for the e-commerce platform Magento.</li>
       <li>Managing, maintaining and setting up various web servers.</li>
       <li>Managed various projects with a team of web developers and designers.</li>
      </ul>
      </TabPanel>
      <TabPanel>
      <h3 className="work-description">Web Developer - Southland Supply Group</h3>
      <p className="work-duration">Aug 2019 - Oct 2020</p>
      <ul className="work-description">
       <li>Redeveloped existing webshops using Magento 2 & Wordpress (Woocommerce).</li>
       <li>Maintained and updated multiple webshops  e.g. updated security, optimized user experience, implemented new features.</li>
       <li>Developed and maintained the front end functionality of websites.</li>
      </ul>
      </TabPanel>
      <TabPanel>
        <h3 className="work-description">Junior Web Developer - More2Make / Wolplein</h3>
        <p className="work-duration">Jun 2017 - Dec 2018</p>
        <ul className="work-description">
         <li>Redeveloped existing webshops using Magento 2 & Wordpress (Woocommerce).</li>
         <li>Maintained and updated multiple webshops  e.g. updated security, optimized user experience, implemented new features.</li>
         <li>Developed and maintained the front end functionality of websites.</li>
        </ul>
      </TabPanel>
      <TabPanel>
        <h3 className="work-description">Web Developer Intern - Aemotion</h3>
        <p className="work-duration">Feb 2016 - Feb 2017</p>
        <ul className="work-description">
         <li>Assisted senior-developers to develop various websites for multiple companies.</li>
         <li>Built multiple Wordpress plugins to add functionality to existing websites.</li>
         <li>Maintained and updated websites made in Drupal 7.</li>
        </ul>
      </TabPanel>
      <TabPanel>
         <Skills></Skills>
      </TabPanel>
    </Tabs>
  );
}
